module.exports = __webpack_public_path__ + "banquet/components/StoreAboutPage/images/about_address_3x.1ffd423cc2904af8eb9480538f6b0f8a.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/StoreAboutPage/images/about_address_3x.png
// module id = 1690
// module chunks = 1